import { AtSignIcon } from "@chakra-ui/icons";
import {
    Alert,
    AlertDescription,
    AlertTitle,
    Box, Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    Link
} from "@chakra-ui/react";
import * as React from "react";
import { HelpFAQ } from "./helpFAQ";
import { useAppConfig } from "../../hooks/useAppConfig";
export interface HelpBannerProps {
  isOpen: boolean;
  onClose: () => void;
  btnRef: React.RefObject<HTMLButtonElement | null>;
}
export const HelpBanner = ({ isOpen, onClose, btnRef }: HelpBannerProps) => {
  const { primaryColor, ctaColor, ctaTextColor, secondaryColor } = useAppConfig();
  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="md"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton colorScheme="red" />
          <DrawerHeader color={primaryColor}>Le domande più frequenti</DrawerHeader>

          <DrawerBody>
            <HelpFAQ />
          </DrawerBody>

          <DrawerFooter>
            <Alert status="info" bgColor={secondaryColor}>
              <AtSignIcon color={ctaTextColor} m="0.4em" fontSize="2xl" />
              <Box flex="1">
                <AlertTitle color={ctaTextColor}>
                  Non hai trovato la soluzione al tuo problema?
                </AlertTitle>
                <AlertDescription color={ctaTextColor} display="block">
                  Chiamaci allo{" "}
                  <Link fontWeight="bold" href="tel:0236638510">
                    02 3663 8510
                  </Link>{" "}
                  o scrivici a{" "}
                  <Link fontWeight="bold" href="mailto:ordini@wishlist.it">
                    ordini@wishlist.it
                  </Link>
                  .
                </AlertDescription>
              </Box>
            </Alert>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
